import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'redux/store';
import { StudentReportState } from './redux';

export const reportStudentSelector = (state: RootState) => state.studentReport;
export const paramsSelector = createSelector(reportStudentSelector, (state: StudentReportState) => state.params);
export const itemViewSelector = createSelector(reportStudentSelector, (state: StudentReportState) => state.itemView);
export const showModalDetailSelector = createSelector(reportStudentSelector, (state: StudentReportState) => state.showModal);
